"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.isIos = function (win) {
  return win && 'navigator' in win ? win.navigator.userAgent.match(/iphone|ipad|ipod/i) !== null : false;
};

exports.isIpad = function (win) {
  return win && 'navigator' in win ? win.navigator.userAgent.match(/ipad/i) !== null : false;
};

exports.isAndroid = function (win) {
  return win && 'navigator' in win ? win.navigator.userAgent.match(/^(?!.*windows phone).*android/i) !== null : false;
};

exports.isHbbTV = function (win) {
  if (win && 'navigator' in win) {
    return win.navigator.userAgent.toLowerCase().indexOf('hbbtv') > -1;
  }

  return false;
};

exports.isMac = function (win) {
  return win && 'navigator' in win ? win.navigator.platform.match(/mac/i) !== null : false;
};

exports.isWindows = function (win) {
  return win && 'navigator' in win ? win.navigator.platform.match(/win/i) !== null : false;
};

exports.getAndroidVersion = function (win) {
  if (!win || !('navigator' in win)) {
    return null;
  }

  var result = win.navigator.userAgent.match(/android (\d+)\.?(\d+)?\.?(\d)?/i);

  if (!result) {
    return null;
  }

  return {
    major: typeof result[1] === 'string' ? Number(result[1]) : null,
    minor: typeof result[2] === 'string' ? Number(result[2]) : null,
    patch: typeof result[3] === 'string' ? Number(result[3]) : null
  };
};

exports.getSafariVersion = function (win) {
  if (!win || !('navigator' in win)) {
    return null;
  }

  var result = win.navigator.userAgent.match(/Version\/(\d+)\.?(\d+)?\.?(\d)\sSafari/);

  if (!result) {
    return null;
  }

  return {
    major: typeof result[1] === 'string' ? Number(result[1]) : null,
    minor: typeof result[2] === 'string' ? Number(result[2]) : null,
    patch: typeof result[3] === 'string' ? Number(result[3]) : null
  };
};